import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'questionBreak'
})
export class QuestionBreakPipe implements PipeTransform {

  //改行コードをマークに変換する
  transform(str:string): string {
    str = str.replace(/\r?\n/g, '<i class="mdi mdi-subdirectory-arrow-left text-secondary"></i>');
    return str;
  }
}


// WEBPACK FOOTER //
// ./src/app/pipes/question-break.pipe.ts